import request from '@/utils/request/index.js'

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
}

function useMobileCode(params) {
  const m = params.mobile
  const c = params.code
  return m != null && String(m).trim() !== '' && c != null && String(c).trim() !== ''
}

export const login = params => {
  const scope = Math.random()
  let data

  const digits = String(params.mobile || '').replace(/\D/g, '')
  const mobile = '+86 ' + digits
  const username = useMobileCode(params) ? mobile : params.email
  const password = useMobileCode(params) ? params.code : params.password

  data =
    'grant_type=password&scope=' +
    scope +
    '&username=' +
    encodeURIComponent(username) +
    '&password=' +
    encodeURIComponent(password)

  return request({
    url: '/oauth/token',
    withCredentials: true,
    data,
    auth: {
      username: 'browser',
      password: 'browser'
    },
    method: 'post',
    headers
  })
}
